// extracted by mini-css-extract-plugin
export default {"main":"Eod_main__B4cKI"};